export default "__VITE_ASSET__BrGj0zLf__"